import React, { useEffect, useRef, useState } from 'react';
import api from '../../plugins/api';
import Button from '../Button/Button';

// Согласие клиента живёт ~5 минут — столько же опрашиваем
const POLL_INTERVAL = 5000;
const POLL_LIMIT = 60;

const GbdflRequest = ({ clientId, onUpdated }) => {
  const [status, setStatus] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const [available, setAvailable] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    api
      .get('/api/crm/clients/gbdfl/available')
      .then(({ data }) => setAvailable(!!data?.available))
      .catch(() => setAvailable(false));
    return () => clearTimeout(timer.current);
  }, []);

  const poll = async (requestId, attempt) => {
    try {
      const { data: res } = await api.post(
        `/api/crm/clients/${clientId}/gbdfl/poll?requestId=${requestId}`
      );
      if (res?.ready) {
        setWaiting(false);
        setStatus({
          type: 'success',
          text: res.message || 'Данные получены',
          fields: res.updatedFields,
        });
        onUpdated && onUpdated();
        return;
      }
      if (res?.finished) {
        setWaiting(false);
        setStatus({ type: 'error', text: res.message || 'Согласие не получено' });
        return;
      }
    } catch (e) {
      setWaiting(false);
      setStatus({ type: 'error', text: e?.response?.data?.errorMessage || 'Ошибка запроса в ГБД' });
      return;
    }

    if (attempt >= POLL_LIMIT) {
      setWaiting(false);
      setStatus({
        type: 'error',
        text: 'Клиент не подтвердил согласие за 5 минут. Заполните данные вручную или повторите запрос.',
      });
      return;
    }
    timer.current = setTimeout(() => poll(requestId, attempt + 1), POLL_INTERVAL);
  };

  const request = async () => {
    setStatus(null);
    setWaiting(true);
    try {
      const { data: res } = await api.post(`/api/crm/clients/${clientId}/gbdfl/request`);
      setStatus({
        type: 'pending',
        text: 'Клиенту отправлено СМС. Для согласия он отвечает 511, для отказа — 512.',
      });
      timer.current = setTimeout(() => poll(res.requestId, 1), POLL_INTERVAL);
    } catch (e) {
      setWaiting(false);
      setStatus({ type: 'error', text: e?.response?.data?.errorMessage || 'Ошибка запроса в ГБД' });
    }
  };

  const colors = { pending: '#6A6A6A', success: '#349D64', error: '#EE7171' };

  if (!available) return null;

  return (
    <div style={{ marginTop: 15 }}>
      <Button
        text={waiting ? 'Ожидаем согласие клиента…' : 'Заполнить из ГБД ФЛ'}
        fill
        full
        disabled={waiting}
        onClick={request}
      />
      {status && (
        <p style={{ color: colors[status.type], fontSize: 13, marginTop: 8, lineHeight: 1.3 }}>
          {status.text}
          {status.fields?.length > 0 && (
            <span style={{ display: 'block', color: '#6A6A6A', marginTop: 4 }}>
              Обновлено: {status.fields.join(', ')}
            </span>
          )}
        </p>
      )}
    </div>
  );
};

export default GbdflRequest;
